import { defineStore } from "pinia";
import Services from '@/services/sutting/bodySubPartsServices'
import { mapList, mapBodySubPart } from '@/helpers/mapFuncs'

export const useBodySubPartsStore = defineStore("bodySubParts", {
persist: true,
state:()=>({
    bodySubPart: {},
    bodySubParts: [],
}),
getters : {
    getBodySubPart() {
        return mapBodySubPart(this.bodySubPart)
    },
    getBodySubParts() {
        return this.bodySubParts.map(mapBodySubPart)
    },
    getBodySubPartsList() {
        return this.bodySubParts.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setBodySubPart(bodySubPart) {
        this.bodySubPart = bodySubPart
    },
    setBodySubParts(bodySubParts) {
        this.bodySubParts = bodySubParts
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setBodySubPart(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setBodySubParts(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.bodySubParts.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.bodySubParts[this.bodySubParts.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.bodySubParts = this.bodySubParts.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
